import { MdCheck, MdClose, MdCompareArrows } from 'react-icons/md';

const DiffPreview = ({
  originalText,
  editedText,
  onAccept,
  onDecline,
  editType,
  sectionDescription
}) => {
  // Determine badge styling and text based on edit type
  const getEditTypeInfo = () => {
    switch (editType) {
      case 'edit_section':
        return {
          label: sectionDescription || 'Section Edit',
          color: 'bg-purple-100 text-purple-800 border-purple-300'
        };
      case 'edit_document':
        return {
          label: 'Full Document Edit',
          color: 'bg-orange-100 text-orange-800 border-orange-300'
        };
      case 'generate_embedded_questions':
        return {
          label: 'Embedded Questions',
          color: 'bg-blue-100 text-blue-800 border-blue-300'
        };
      case 'edit':
        return {
          label: 'Text Selection Edit',
          color: 'bg-green-100 text-green-800 border-green-300'
        };
      default:
        return {
          label: 'Edit Suggestion',
          color: 'bg-gray-100 text-gray-800 border-gray-300'
        };
    }
  };

  const editTypeInfo = getEditTypeInfo();

  return (
    <div className="inline-diff-preview bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 rounded-r-lg p-4 my-2 shadow-lg animate-fadeIn pointer-events-auto" style={{ position: 'sticky', top: '10px', zIndex: 10 }}>
      {/* Compact Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <MdCompareArrows className="text-blue-600" size={18} />
          <h4 className="text-sm font-semibold text-blue-900">AI Edit Suggestion</h4>
        </div>
        {/* Edit Type Badge */}
        <span className={`text-[11px] font-semibold px-2.5 py-1 rounded border ${editTypeInfo.color}`}>
          {editTypeInfo.label}
        </span>
      </div>

      {/* Side-by-side comparison for better space usage */}
      <div className="grid grid-cols-2 gap-3 mb-4">
        {/* Original Text */}
        <div>
          <div className="flex items-center space-x-1 mb-1.5">
            <div className="w-0.5 h-3 bg-red-400 rounded"></div>
            <span className="text-[11px] font-medium text-gray-500 uppercase tracking-wide">Original</span>
          </div>
          <div className="bg-red-50/80 border border-red-200 rounded p-3 max-h-96 overflow-y-auto">
            <pre className="text-sm text-gray-800 whitespace-pre-wrap font-mono leading-relaxed">
              {originalText}
            </pre>
          </div>
        </div>

        {/* Edited Text */}
        <div>
          <div className="flex items-center space-x-1 mb-1.5">
            <div className="w-0.5 h-3 bg-green-400 rounded"></div>
            <span className="text-[11px] font-medium text-gray-500 uppercase tracking-wide">Suggested</span>
          </div>
          <div className="bg-green-50/80 border border-green-200 rounded p-3 max-h-96 overflow-y-auto">
            <pre className="text-sm text-gray-800 whitespace-pre-wrap font-mono leading-relaxed">
              {editedText}
            </pre>
          </div>
        </div>
      </div>

      {/* Compact Action Buttons */}
      <div className="flex items-center justify-end space-x-2 pt-2 border-t border-blue-200">
        <button
          onClick={onDecline}
          className="flex items-center space-x-1 px-3 py-1.5 bg-white text-gray-600 border border-gray-300 rounded hover:bg-gray-50 transition-colors duration-200 text-xs font-medium"
        >
          <MdClose size={14} />
          <span>Decline</span>
        </button>
        <button
          onClick={onAccept}
          className="flex items-center space-x-1 px-3 py-1.5 bg-green-600 text-white rounded hover:bg-green-700 transition-colors duration-200 text-xs font-medium shadow-sm"
        >
          <MdCheck size={14} />
          <span>Accept</span>
        </button>
      </div>
    </div>
  );
};

export default DiffPreview;
